<script setup lang="ts">
  import { useI18 } from '@/plugins';

  const search = defineModel<string | null>('search', {
    required: true,
  });
  const emit = defineEmits<{
    (event: 'update'): void;
  }>();
  const { t } = useI18();
</script>
<template>
  <v-text-field
    v-model.trim="search"
    :placeholder="t('header.searchForCourses')"
    prepend-inner-icon="mdi-magnify"
    variant="solo-filled"
    flat
    density="compact"
    hide-details
    rounded
    clearable
    @update:model-value="emit('update')"
  ></v-text-field>
</template>
